// ==============================================================================
// Imports
// ==============================================================================

import React from "react";
import DOMPurify from "dompurify";
import {connect} from "react-redux";

// ==============================================================================
// Sales Report Page Component
// The Sales Report page that is displayed in an external window
// ==============================================================================

class SalesReportPage extends React.Component {

    logoAndHeader(countryName) {
        return (
            <div>
                <div className="report-header-container">

                            <img
                                className="worldview-logo"
                                src="https://marvel.globaldataconsortium.com/assets/images/WorldviewLogo_With_TM_02.png"
                                alt="Worldview"
                            />
                            <img
                                className="gdc-logo"
                                src="https://marvel.globaldataconsortium.com/assets/images/GDCLogo_Full_With_TM_250t.png"
                                alt="GDC Logo"
                            />
                </div>
                <h1 className="report-header">{countryName}</h1>
            </div>
        );
    }

    render () {

        const {sourcesArr} = this.props;

        let countriesIncluded = [];
        sourcesArr.forEach(source => {
            source["formattedInputKeys"] = []
            // test if the country has already been added, if not - add it
            if (!countriesIncluded.includes(source.country_label)) {
                countriesIncluded.push(source.country_label);
            }

            // formatting the newly created DS into a more react friendly structure
            // which can then be rendered into the report.
            for (let [key, value] of Object.entries(source.required_inputs)) {
                for (let [k, v] of Object.entries(value)) {
                    source.formattedInputKeys.push({
                        id: k,
                        country_iso: key,
                        elements: v.join(", ")
                    })
                }
            }
        });

        return (
            <div className="report-page-container">
                {/*{countriesIncluded.length === 1*/}
                {/*    ? this.logoAndHeader(countriesIncluded[0])*/}
                {/*    : ("")*/}
                {/*}*/}

                {sourcesArr.map((source, idx) => (
                    <div className="source-individual-container" key={idx}>
                        {this.logoAndHeader(source.country_name)}

                        <div className="report-source-data-container">
                            <h2 className="report-source-header">
                                {source.source_type} {source.source_type_identifier}
                            </h2>

                            <div className={"report-key-data-container"}>
                                {/*Currently keeping this commented.*/}
                                {/*{source.sub_dp_type !== null &&*/}
                                {/*    source.sub_dp_type !== ""*/}
                                {/*    ? (*/}
                                {/*        <h4 className="report-key-data">*/}
                                {/*            Sub Source Type: {lodash.find(subDPTypeOptions, {*/}
                                {/*            value: source.sub_dp_type*/}
                                {/*        }).label}*/}
                                {/*        </h4>*/}
                                {/*    )*/}
                                {/*    : ("")}*/}


                                {source.overall_coverage !== null &&
                                source.overall_coverage !== "" ? (
                                    <h4 className="report-key-data">
                                        Coverage: {source.overall_coverage}{" "}{source.coverage_type === null
                                        ? ""
                                        : source.coverage_type}
                                    </h4>
                                ) : (
                                    ""
                                )}

                                {source.data_refresh_frequency !== null &&
                                source.data_refresh_frequency !== "" ? (
                                    <h4 className="report-key-data">
                                        Data Refresh Frequency: {source.data_refresh_frequency}
                                    </h4>
                                ) : (
                                    ""
                                )}
                            </div>

                            <div className="report-source-description">
                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(source.source_type_description) }} />
                            </div>

                            {/*Commenting this out because today we do not send the resource-url from the API.*/}

                            {/*{source.resource_url !== null && source.resource_url !== "" ? (*/}
                            {/*    <p className="report-source-resource-url">*/}
                            {/*        Additional Information:{" "}*/}
                            {/*        <a href={source.resource_url}>{source.resource_url}</a>*/}
                            {/*    </p>*/}
                            {/*) : (*/}
                            {/*    ""*/}
                            {/*)}*/}

                            {source.required_inputs.length > 0 ||
                            source.verifiable_inputs.length > 0 ? (
                                <h3 className="report-source-subheader">Inputs:</h3>
                            ) : (
                                ""
                            )}

                            <table className="report-inputs-table">
                                <tbody>
                                {Object.keys(source.required_inputs).length > 0 ? (
                                    <tr>
                                        <td className="report-element-label">
                                            Required Input Options
                                        </td>
                                        <td className="report-element-list">
                                            <ul>
                                                {source.formattedInputKeys.map((inputGroup, idx) => (
                                                     <li key={idx}>{inputGroup.elements}</li>
                                                ))}
                                            </ul>
                                        </td>
                                    </tr>
                                ) : (
                                    ""
                                )}
                                {source.verifiable_inputs.length > 0 ? (
                                    <tr>
                                        <td className="report-element-label">Verifiable Elements</td>
                                        <td className="report-element-list">
                                            <ul>
                                                {source.verifiable_inputs.map((input, idx) => (
                                                    <li key={idx}>{input}</li>
                                                ))}
                                            </ul>
                                        </td>
                                    </tr>
                                ) : (
                                    ""
                                )}
                                </tbody>
                            </table>

                            {source.verifiable_inputs.length > 0 ? (
                                <p className="report-footnote">
                                    *** To verify an element with Worldview, that element is
                                    required to be passed in to the API.
                                </p>
                            ) : (
                                ""
                            )}

                            {source.consent_required === 'YES' ? (
                                <p className="consent-required-text">
                                    This source requires Consent.
                                </p>
                            ) : (
                                ""
                            )}

                            {source.credit_footprint === 'YES' ? (
                                <p className="consent-required-text">
                                    This source leaves a Credit Footprint.
                                </p>
                            ) : (
                                ""
                            )}

                            {source.note !== "" && source.note !== null ? (
                                <div className="customer-notes-container">
                                    <h4 className="report-source-subheader">Notes:</h4>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(source.note) }} />
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    sourcesArr: state.report.pdfReports.veritasSelectedSources,
    subDPTypeOptions: state.veritas.kybServices.kybFilterOptions.subDPTypeOptions,
});

export default connect(
    mapStateToProps,
)(SalesReportPage);
